export const TOAST_DURATION_IN_MS = 7000;

export const TOAST_CLASS_NAME = 'toolkit-react-hot-toast';
